import type {ReactNode} from 'react';

export type RegionId =
	'nordreLand' | 'gjovik' | 'sondreLand' | 'vestreToten' | 'ostreToten';

export type RegionDef = {
	id: RegionId;
	label: string;
	defaultD: string;
	defaultElement: 'path' | 'polygon';
	hoverD: string;
	hoverElement: 'path' | 'polygon';
	labelTransform: string;
	labelTspans: ReactNode;
};

export const REGIONS: RegionDef[] = [
	{
		id: 'nordreLand',
		label: 'Nordre Land',
		defaultElement: 'path',
		defaultD:
			'M58.57,24.92l24.76,7.11,4.25,2.61.34,2.65-.89,5.17-.13.76.57.52,5.88,5.37.64.58.81-.3,6.74-2.49-.37,5.25v.18s.02.18.02.18l.6,3.19.13.7.64.31,17.08,8.4,8.68,11.61.29.38.46.13,6.29,1.8s.04.04.05.07l.5.62c.78.96,2.3,2.86,4.85,6.04l1.05,1.31-2.4,4.34-.14.25-.03.28-1.17,10.62-9.83,20.94-.34.72.44.66,10.65,16.16,1.51,9.29.07.46.33.33,5.41,5.27-2.5,2.54-.42.43v.6s.29,14.31.29,14.31l-2.61,5.5-8.05.65-6.1-3.7-.86-.52-.78.64-6.5,5.34-1.1.91.92,1.1,5.87,7.02.32.39.49.1,3.82.74h.04s.04.01.04.01l5.31.72-2.32,1.7-15.03,2.99-.28.05-.23.16-6.29,4.19-1.23.82.87,1.19,1.87,2.56-.7,3.95-1.87,1.52-2.65-1.42-.92-.49-.74.73-5.67,5.54-4.94-3.27-.71-.47-.75.41-3.78,2.06-12.85-11.07-1.18-1.01-.9,1.26-10.63,14.86-4.7-1.31-5.41-9.75,1.84-20.45.02-.23-.05-.23-3.04-12.64-.17-.69-.65-.28-4.43-1.92,5.63-22.59.09-.35-.09-.35-2.37-9.35,1.1-12.14.02-.2-.04-.2-4.36-22.7,2.59-6.8.71-1.88-2.01-.04-1.73-.04-4.34-15.28,1.52-.22.8-.12.31-.75,6.82-16.82.51-1.27-1.25-.56-5.74-2.56-.54-.24-.55.22-9.38,3.69-4.78-23.22-.03-.15-.06-.14-3.81-8.53-.18-.39-.36-.23-3.45-2.17,9.52-.59,17.56,6.98.31.12.33-.03,8.64-.69,1.57-.13-.29-1.55-1.08-5.74',
		hoverElement: 'path',
		hoverD: 'M103.1,44.82l-8.8,3.25-5.88-5.37.93-5.38-.45-3.53-4.99-3.06-27.16-7.8,1.5,8-8.64.69-17.85-7.1-14.23.88,7.18,4.51,3.81,8.53,5.12,24.87,10.94-4.3,5.74,2.56-6.82,16.82-3.12.46,5.06,17.85,2.77.06-2.73,7.18,4.43,23.09-1.13,12.39,2.43,9.58-5.92,23.75,5.53,2.4,3.04,12.64-1.87,20.88,5.91,10.65,6.22,1.74,11.21-15.66,13.6,11.71,4.64-2.53,5.89,3.91,6.48-6.34,3.48,1.87,3.01-2.46.89-5.07-2.23-3.05,6.29-4.19,15.34-3.05,5.4-3.97-8.78-1.19-3.82-.74-5.87-7.02,6.5-5.34,6.5,3.94,9.32-.75,3.11-6.54-.28-14.64,3.5-3.56-6.43-6.27-1.55-9.59-10.82-16.42,9.93-21.15,1.2-10.85,2.86-5.17c-3.55-4.43-5.56-6.94-6.5-8.1-.48-.59-.71-.89-.84-1.04l-6.72-1.92-8.88-11.89-17.39-8.55-.6-3.19.52-7.44Z',
		labelTransform: 'translate(72.51 114.8)',
		labelTspans: (
			<>
				<tspan x="0" y="0">
					No
				</tspan>
				<tspan x="16.77" y="0" letterSpacing="-.02em">
					r
				</tspan>
				<tspan x="21.24" y="0">
					d
				</tspan>
				<tspan x="28.89" y="0" letterSpacing="-.02em">
					r
				</tspan>
				<tspan x="33.36" y="0">
					e{' '}
				</tspan>
				<tspan x="5.91" y="15.31">
					Land
				</tspan>
			</>
		),
	},
	{
		id: 'gjovik',
		label: 'Gjøvik',
		defaultElement: 'path',
		defaultD:
			'M158.22,82.72l11.45,4.46,7.34,3.82.73.38.69-.45,5.16-3.33,9.59-.36.53-.02.39-.37,2.19-2.07,1.64,5.34.11.37.28.26,14.46,13.33.04.04.05.04,19.41,15.09,7.39,11.54,6.08,19.06.05.17.1.15,7.5,11.96-8.06,19.13-.25.59.28.58,8.67,17.78-6.3,6.5-18.59.93-.74.04-.39.63-1.67,2.71-.22.36v.42s.06,1.77.06,1.77l-1.68-.41-.71-.18-.55.48-1.05.91-3.5-2.59-.9-.67-.86.72-3.95,3.32-.28.24-.13.34-1.88,4.95-4.66,1.94-.63.26-.19.66-.7,2.5-20.81-21.23-.74-2.42-.15-.48-.41-.28-7.37-5.03-.48-14.35,3.45-6.37.18-.33v-.37s-.15-8.42-.15-8.42l-.02-1.15-1.13-.22-5.04-.97-2.59-3.01-.46-.54-.71.05-2.68.19-12.41-10.76-1-.87-.93.95-2.63,2.67-4.81-4.66-1.46-8.95-.05-.3-.17-.25-10.16-15.33,9.4-19.91.1-.21.03-.23,1.17-10.51,2.47-4.46,13.26-5.58',
		hoverElement: 'polygon',
		hoverD: '196.99 82.18 193.14 85.82 183.15 86.2 177.66 89.74 170.25 85.88 158.2 81.19 143.96 87.19 141.11 92.32 139.91 103.11 130.17 123.75 140.77 139.74 142.31 149.16 148.46 155.13 152.08 151.46 164.94 162.6 168.21 162.37 171.11 165.76 176.64 166.82 176.79 175.24 173.15 181.95 173.67 197.4 181.63 202.84 182.47 205.59 205.23 228.81 206.6 223.95 211.83 221.78 213.92 216.25 217.87 212.93 222.28 216.2 224.19 214.54 227.68 215.41 227.58 211.77 229.25 209.06 248.4 208.09 255.78 200.48 246.68 181.8 255.03 161.99 247.13 149.41 240.99 130.17 233.37 118.27 213.76 103.04 199.3 89.71 196.99 82.18',
		labelTransform: 'translate(179.24 145.57)',
		labelTspans: (
			<>
				<tspan x="0" y="0">
					Gj
				</tspan>
				<tspan x="12.69" y="0" letterSpacing="-.02em">
					ø
				</tspan>
				<tspan x="19.82" y="0">
					vik
				</tspan>
			</>
		),
	},
	{
		id: 'sondreLand',
		label: 'Søndre Land',
		defaultElement: 'path',
		defaultD:
			'M152.45,155.64l11.35,9.81.44.38.58-.04,2.45-.17,2.32,2.69.32.38.49.09,3.8.73.09,5.43-3.47,6.39-.18.34v.39s.57,16.49.57,16.49l.02.72.6.4,7.73,5.25.65,2.13.1.33.24.25,22.05,22.45-1.41.94-.48.32-.12.56-2.56,11.87-.03.16v.16s.19,13.82.19,13.82l.02,1.2,1.19.18,5.9.89.26.04.26-.06,4.2-.93,2.2,3.79-.69,1.8-.21.54.23.53,1.3,2.99-4.09,13.49-2.17,1.04-.6.29-.16.64-2.45,9.67-26.2,5.76-.39.09-.29.28-2.42,2.34-6.1,1.03-.59.1-.34.5-4.17,6.07-19.29-1.88-17.88-7.46-.8-.34-.66.57-5.54,4.73-3.63-6.37-6.27-23.07-.06-.22-.13-.19-6.32-9.51.02-.08.07-.27-.04-.28-1.97-14.41-.02-.11-.03-.11-9.89-32.29,2.12-1.15,5.45,3.57.95.62.81-.79,5.84-5.67,2.51,1.34.83.44.73-.59,4.1-3.31.41-.33.09-.52,1.09-6.12.11-.6-.36-.49-.85-1.16,3.45-2.28,15.19-3,.31-.06.25-.18,8.38-6.11,2.85-2.08-3.5-.47-12.08-1.62-2.81-.54-3.46-4.11,2.86-2.33,5.25,3.16.39.24.46-.04,10.55-.85.81-.07.35-.73,3.59-7.5.15-.3v-.34s-.27-13.76-.27-13.76l2.71-2.74.46-.46,2.29-2.31',
		hoverElement: 'polygon',
		hoverD: '149.16 156.95 148.7 157.41 145.56 160.57 145.84 174.93 142.24 182.43 131.69 183.28 125.59 179.6 120.84 183.47 125.55 189.06 128.89 189.71 141.01 191.33 132.63 197.44 117.17 200.49 112.25 203.75 113.98 206.11 112.9 212.23 108.8 215.54 105.37 213.72 98.79 220.11 92.63 216.07 88.74 218.18 98.97 251.58 100.94 265.99 100.75 266.69 107.42 276.73 113.74 299.97 117.61 306.77 118.64 307.71 125.15 302.15 143.22 309.69 163.56 311.67 168.2 304.92 174.73 303.81 177.47 301.17 204.52 295.22 207.19 284.7 209.92 283.39 214.35 268.8 212.83 265.34 213.77 262.91 210.71 257.63 205.5 258.79 199.61 257.9 199.42 244.08 201.98 232.21 203.82 230.98 204.82 230.31 181.57 206.64 180.77 204.03 172.62 198.49 172.07 182 175.71 175.29 175.6 168.33 170.67 167.39 167.88 164.16 164.73 164.38 152.38 153.7 149.16 156.95',
		labelTransform: 'translate(130.98 242.95)',
		labelTspans: (
			<>
				<tspan x="0" y="0">
					Sønd
				</tspan>
				<tspan x="29.76" y="0" letterSpacing="-.02em">
					r
				</tspan>
				<tspan x="34.22" y="0">
					e{' '}
				</tspan>
				<tspan x="6.34" y="15.31">
					Land
				</tspan>
			</>
		),
	},
	{
		id: 'vestreToten',
		label: 'Vestre Toten',
		defaultElement: 'path',
		defaultD:
			'M246.21,210.87l-.13,1.53-.04.54.32.43,4.09,5.44-.13,6.28-.02.79.67.43,3.31,2.13,1.48.95-.18,2.04-.77,3.97-.08.4.15.38,1.57,4.02-3.47.99-1.01.29-.02,1.05-.1,4.92-9.16,6.36-.96.67.48,1.07,1.82,4.09-1.42,1.52-.13.14-.09.16-3.86,7.24-.17.31v.35s-.03,12.19-.03,12.19v.28s.1.26.1.26l2.67,6.65-.04,7.36v.61s.44.42.44.42l4.07,3.85-.23,10.66v.34s.14.31.14.31l2.59,5.38-8.42.95-1.46.16.21,1.45.34,2.35-1.54.36-.47-1.94-.26-1.08h-2.88l-.21-3.52-.07-1.27-1.27-.06-5.57-.27,3.06-5.6.97-1.77-1.99-.31-5.03-.78-4.13-8.39-.62-1.26-1.27.61-1.58.76-.91-2.97-.3-.98-1.03-.02-6.62-.14,1.81-7.18,2.11-1.02.56-.27.18-.6,4.75-15.74.15-.5-.21-.48-1.26-2.9.77-2.01.24-.63-.34-.58-3.88-6.72-.52-.9-1.02.23-5.66,1.27-3.09-.47-.15-11.25,2.26-10.54,2.8-1.88.43-.29.14-.5,1.38-4.94,4.55-1.9.56-.24.22-.57,2.05-5.44,1.76-1.48,3.52,2.63.91.68.86-.75,1.65-1.43,3.83.95,1.81.45-.06-1.87-.14-4.61.49-.79,15.66-.78',
		hoverElement: 'polygon',
		hoverD: '202.5 232.76 200.09 244.02 200.26 256.62 204.8 257.32 210.72 255.99 214.61 262.71 213.63 265.26 215.12 268.69 210.37 284.43 207.66 285.74 205.26 295.3 213.66 295.48 215.05 300.03 218.12 298.55 222.57 307.6 228.33 308.5 224.19 316.08 232.01 316.46 232.3 321.31 235.4 321.31 236.2 324.62 240.37 323.65 239.84 320.01 249.74 318.9 249.76 317.85 246.79 311.66 247.03 300.38 242.51 296.09 242.55 288.46 239.78 281.54 239.81 269.35 243.67 262.12 245.72 259.91 243.53 254.97 253.28 248.19 253.4 242.55 258.36 241.13 256.22 235.66 257 231.62 257.65 224.06 255.87 223.93 255.06 227.24 251.74 225.11 251.89 218.34 247.5 212.52 247.76 209.37 229.74 210.27 228.64 212.05 228.79 217.09 224.24 215.96 222.04 217.87 217.61 214.56 214.72 217.01 212.53 222.79 207.35 224.95 205.78 230.55 202.5 232.76',
		labelTransform: 'translate(210.43 236.75)',
		labelTspans: (
			<>
				<tspan x="0" y="0" letterSpacing="-.08em">
					V
				</tspan>
				<tspan x="7.53" y="0">
					est
				</tspan>
				<tspan x="24.21" y="0" letterSpacing="-.02em">
					r
				</tspan>
				<tspan x="28.68" y="0">
					e
				</tspan>
				<tspan x="1.92" y="15.31" letterSpacing="-.08em">
					T
				</tspan>
				<tspan x="8.08" y="15.31" letterSpacing="0em">
					ot
				</tspan>
				<tspan x="19.42" y="15.31">
					en
				</tspan>
			</>
		),
	},
	{
		id: 'ostreToten',
		label: 'Østre Toten',
		defaultElement: 'path',
		defaultD:
			'M255.92,204.08l1.02,2.13.15.32.29.21,9.79,7.17.2.14.23.07,13.95,4.18,11.4,11.64.07.07.08.06,28.96,22.42h0s.55.43.55.43l.37.29,6.32,4.88,3.26,4.51,5.32,9.39,2.05,6.44.05.17.1.15,2,3.17-3.31,2.65-.31.25-.14.37-2.93,7.89-.12.31.04.33.26,2.46-1.47,2.11-.18.25-.06.3-3.04,16.67-2.59,1.69-17.67,8.6-1.84-.48-.6-.16-.52.33-6.37,4.03-.73.46.08.86.37,4.06-7.15,2.41-7.09-3.62-.37-.19-.41.04-11.1,1.07-13.68-5.97-8.99-12.43-2.36-5.04.23-11.25v-.62s-.43-.43-.43-.43l-4-3.88.05-6.72v-.27s-.1-.26-.1-.26l-2.62-6.67.02-10.98,3.29-6.32,2.37-2.6.62-.68-.36-.84-1.6-3.7,8.26-5.88.58-.41.02-.71.09-4.3,4.32-1.27,1.48-.43-.55-1.44-2.35-6.14.64-3.32v-.07s.02-.07.02-.07l.76-9,.12-1.42-1.42-.11-4.16-.33-.36-.03.06-3.14v-.48s-.28-.39-.28-.39l-3.96-5.36.17-2.13,5.18-5.48',
		hoverElement: 'polygon',
		hoverD: '256.31 201.6 249.37 208.95 249.11 212.11 253.38 217.9 253.25 224.39 254.35 225.1 254.98 222.5 259.14 222.83 258.38 231.83 257.66 235.55 260.16 242.07 254.84 243.62 254.72 248.96 245.53 255.5 247.58 260.26 245.09 262.99 241.55 269.78 241.52 281.38 244.24 288.3 244.19 295.62 248.63 299.92 248.39 311.5 250.95 316.96 260.25 329.8 274.61 336.08 286.08 334.97 293.7 338.86 302.48 335.9 302.01 330.73 308.38 326.7 310.73 327.32 328.95 318.45 332.12 316.38 335.27 299.11 337.05 296.57 336.72 293.58 339.65 285.69 343.81 282.37 343.82 282.04 341.28 278.01 339.18 271.43 333.75 261.85 330.32 257.11 323.84 252.1 323.47 251.81 323.47 251.8 293.96 228.96 282.31 217.06 268.01 212.77 258.22 205.6 256.31 201.6',
		labelTransform: 'translate(274.39 276.38)',
		labelTspans: (
			<>
				<tspan x="0" y="0">
					Øst
				</tspan>
				<tspan x="19.68" y="0" letterSpacing="-.02em">
					r
				</tspan>
				<tspan x="24.15" y="0">
					e
				</tspan>
				<tspan x="-.34" y="15.31" letterSpacing="-.08em">
					T
				</tspan>
				<tspan x="5.82" y="15.31" letterSpacing="0em">
					ot
				</tspan>
				<tspan x="17.16" y="15.31">
					en
				</tspan>
			</>
		),
	},
];

export const REGION_ORDER: RegionId[] = [
	'nordreLand',
	'gjovik',
	'sondreLand',
	'vestreToten',
	'ostreToten',
];
